export enum ViewingPlatform {
  FACEBOOK = 'facebook',
  INSTAGRAM = 'instagram',
  NBLOG = 'nblog',
  NKIN = 'nkin',
  NPLACE = 'nplace',
  THREADS = 'threads',
  YOUTUBE = 'youtube',
}
